import { PhoneCall, Send, Hammer, ArrowRight } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: PhoneCall,
    title: "On fait connaissance",
    text: "Un appel de 30 minutes pour comprendre votre activité, vos clients types et vos besoins. Gratuit, sans engagement.",
  },
  {
    n: "02",
    icon: Send,
    title: "On prend le relais",
    text: "Vous nous transmettez vos infos par message, photo ou email. On rédige, on envoie, on suit. Vous ne touchez plus à rien.",
  },
  {
    n: "03",
    icon: Hammer,
    title: "Vous récupérez du temps",
    text: "Plus de soirées sur les devis. Plus de clients impayés oubliés. Vous travaillez, on administre.",
  },
];

export default function Solution() {
  return (
    <section
      id="solution"
      data-testid="solution-section"
      className="bg-white py-20 sm:py-28 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <span className="inline-block text-[#E8611A] font-semibold text-sm tracking-widest uppercase mb-4">
            La solution
          </span>
          <h2 className="font-display font-extrabold text-[#1A2E4A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Comment ça fonctionne
          </h2>
          <p className="mt-4 text-[#8A8A8A] text-base sm:text-lg">
            Simple, rapide, sans engagement.
          </p>
        </div>

        <div className="mt-14 sm:mt-20 relative">
          {/* Timeline line (desktop) */}
          <div className="hidden md:block absolute top-12 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-[#1A2E4A]/20 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {STEPS.map(({ n, icon: Icon, title, text }, i) => (
              <div
                key={n}
                data-testid={`step-${i}`}
                className="reveal relative"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="flex flex-col items-start">
                  <div className="relative mb-6">
                    <span className="relative z-10 inline-flex items-center justify-center w-24 h-24 rounded-sm bg-[#1A2E4A] text-white border-4 border-white shadow-md">
                      <Icon className="w-9 h-9" strokeWidth={2} />
                    </span>
                    <span className="absolute -top-2 -right-3 z-20 inline-flex items-center justify-center min-w-9 h-9 px-2 rounded-sm bg-[#E8611A] text-white font-display font-bold text-sm">
                      {n}
                    </span>
                  </div>
                  <h3 className="font-display font-bold text-[#1A2E4A] text-2xl">
                    {title}
                  </h3>
                  <p className="mt-3 text-[#2D2D2D]/75 text-base leading-relaxed">
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 sm:mt-20 text-center reveal">
          <a
            href="#services"
            data-testid="solution-cta"
            className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-sm bg-[#E8611A] text-white font-semibold hover:bg-[#E8611A]/90 transition-all hover:-translate-y-0.5 shadow-lg shadow-[#E8611A]/20"
          >
            Je veux essayer — 1er mois à tarif réduit
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
